module.exports = __webpack_public_path__ + "static/img/header.37480036.png";